module.exports = __webpack_public_path__ + "static/fonts/Arita-dotumM.00946d8.ttf";